/// <reference no-default-lib="true"/>
/* eslint-disable */
import { useState, useEffect } from 'react';
import { Box, Card, Container, TextField, Button, TableContainer, Table, TableRow, TableCell, TableBody, TableHead, Modal, Typography, DialogActions, IconButton, Dialog, DialogTitle } from '@mui/material';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import HeaderSession from '../../../../utils/headerSession';
import Loading from '../../../../load/loading';
import LoadingShort from '../../../../load/loadingShort';
import api from '../../../../services/api';
import Montante from '../../../../utils/montante';
import MessageSuccess from '../../../../messages/messageSuccess';
import MessageError from '../../../../messages/messageError';
import { MdDeleteOutline } from "react-icons/md";
import { FaEdit } from 'react-icons/fa';
import Delete from '../../../../utils/delete';

export default function OutrosEmolumentos() {
    const estilo = {
        position: 'absolute',
        top: '30%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        padding: 4,
    }

    const user = useSelector((state: RootState) => state.account.user);
    const [addEmolumento, setAddEmolumento] = useState({ designacao: '', valor: '' });
    const [emolumentoCriado, setEmolumentoCriado] = useState([]);
    const [loading, setLoading] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('');
    const [messageError, setMessageError] = useState('');
    // const [Linhas, setLinhas] = useState([]);
    // const [linha, setLinha] = useState({ descricao: '', valor: '', tipo_emolumento: '' });
    const [editar, setEditar] = useState(null);
    const [refreshPage, setRefreshPage] = useState(false);
    const [aberto, setAberto] = useState(false);
    const modalAberto = () => setAberto(true);
    const [deleteId, setDeleteId] = useState(null);
    const [open, setOpen] = useState(false);

    const modalFechado = () => {
        setAberto(false);
        setAddEmolumento('');
        setEditar(null)
    };

    useEffect(() => {
        fetchEmolumentos();
    }, [refreshPage]);

    const fetchEmolumentos = () => {
        setLoading(true);
        api
            .get(`/emolumentos`)
            .then((response) => {
                setLoading(false);
                setEmolumentoCriado(response.data.emolumentos || []);
            })
            .catch((err) => {
                setLoading(false);
                setMessageError(err.response?.data?.message || 'Erro ao buscar emolumentos');
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddEmolumento((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const createEmolumento = () => {
        setLoading(true);
        api
            .post('/emolumento/create', { ...addEmolumento, userId: user._id })
            .then((response) => {
                setLoading(false);
                setMessageSuccess(response.data.msg);
                setEmolumentoCriado((prevState) => [...prevState, addEmolumento]);
                setAddEmolumento({ designacao: '', valor: '' });
                modalFechado();
                setRefreshPage((prev) => !prev);
            })
            .catch((err) => {
                setLoading(false);
                setMessageError(err.response?.data?.message || 'Erro ao criar o emolumento');
            });
    };

    const editarEmolumento = () => {
        setLoading(true);
        api
            .post('/emolumento/edit', { ...addEmolumento, userId: user._id, emolumentoId: addEmolumento?._id })
            .then((response) => {
                setLoading(false);
                setMessageSuccess(response.data.msg);
                setEmolumentoCriado((prevState) => [...prevState, addEmolumento]);
                setAddEmolumento({ designacao: '', valor: '', efeito: '' });
                modalFechado();
                setRefreshPage((prev) => !prev);
            })
            .catch((err) => {
                setLoading(false);
                setMessageError(err.response?.data?.message || 'Erro ao editar o emolumento');
            });
    };

    //   const deleteEmolumento = () => {
    //     setLoading(true);
    //     api
    //       .delete('/emolumento/delete', {
    //         data: {
    //           emolumentoId: addEmolumento?._id,
    //           userId: user._id
    //         }
    //       })
    //       .then((response) => {
    //         setLoading(false);
    //         setMessageSuccess(response.data.msg);
    //         handleClose();
    //         setRefreshPage(true);
    //       })
    //       .catch((err) => {
    //         setLoading(false);
    //         setMessageError(err.response?.data?.message);
    //         handleClose();
    //       });
    //   };

    const deleteEmolumento = (id) => {
        setLoading(true);
        api
            .delete('/emolumento/delete', {
                data: {
                    emolumentoId: id,
                    userId: user._id
                }
            })
            .then((response) => {
                setLoading(false);
                setMessageSuccess(response.data.msg);
                setRefreshPage(true);
            })
            .catch((err) => {
                setLoading(false);
                setMessageError(err.response?.data?.message);
            });
    };

    const handleDelete = (id) => {
        setDeleteId(id);
        setOpen(true);
    };

    return (
        <Container>
            <HeaderSession title={'EMOLUMENTOS'} />
            <DialogActions>
                <Button
                    variant="contained"
                    style={{ backgroundColor: '#99288b' }}
                    onClick={modalAberto}>
                    Adicionar novo emolumento
                </Button>
            </DialogActions>
            <Card>
                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && <MessageError message={messageError} />}

                <Box>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Designação</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 'bold' }}>Valor</TableCell>
                                    <TableCell align='left' sx={{ fontWeight: 'bold' }}>Tipo de Emolumento</TableCell>
                                    <TableCell align='center' sx={{ fontWeight: 'bold' }}>Açōes</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    emolumentoCriado.length > 0 ?
                                        (emolumentoCriado.map((emolumento, index) => (
                                            <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell >{emolumento?.designacao}</TableCell>
                                                <TableCell align='left'><Montante montante={emolumento?.valor} /></TableCell>
                                                <TableCell align='left'>{emolumento?.tipo}</TableCell>

                                                <TableCell align='center' style={{ display: 'flex' }}>
                                                    <IconButton style={{ color: '#99288b' }}
                                                        onClick={() => {
                                                            setEditar(index);
                                                            setAddEmolumento(emolumento);
                                                            setAberto(true);
                                                        }}>
                                                        <FaEdit size={21} />
                                                    </IconButton>

                                                    <IconButton style={{ color: '#99288b' }} onClick={() => handleDelete(emolumento?._id)}>
                                                        <MdDeleteOutline size={22} />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        )))
                                        : <Loading />
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>

                <Modal open={aberto} onClose={modalFechado}>
                    <Box sx={estilo} style={{ display: 'flex', flexDirection: 'column', gap: '7px' }}>
                        <Typography sx={{ fontWeight: '450', textAlign: 'center', fontSize: '22px', textTransform: 'uppercase' }}>{editar != null ? 'Editar emolumento' : 'Adicionar emolumento'}</Typography>

                        {messageError && <MessageError message={messageError} />}

                        <TextField
                            id="outlined-basic"
                            label="Designação do emolumento"
                            variant="outlined"
                            fullWidth
                            size='small'
                            name="designacao"
                            defaultValue={addEmolumento.designacao}
                            onChange={handleChange}
                        />

                        <TextField
                            id="outlined-basic"
                            label="Valor"
                            variant="outlined"
                            fullWidth
                            name="valor"
                            type="number"
                            size='small'
                            defaultValue={addEmolumento.valor}
                            onChange={handleChange}
                        />

                        {editar != null ?
                            <Button variant='contained' type='button' style={{ backgroundColor: '#99288b', width: '100%' }} onClick={() => editarEmolumento()}>{loading ? <LoadingShort /> : 'Editar'}</Button>
                            : <Button variant='contained' type='button' style={{ backgroundColor: '#99288b', width: '100%' }} onClick={() => createEmolumento()}>{loading ? <LoadingShort /> : 'Adicionar'}</Button>
                        }
                    </Box>
                </Modal>

                {deleteId && (
                    <Delete
                        url="emolumento/delete"
                        id={deleteId}
                        tipo={"Emolumento"}
                        open={open}
                        setOpen={setOpen}
                        msg={`Tem certeza que deseja eliminar este emolumento`}
                    />
                )}

                {/* <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Deseja realmente apagar o Emolumento?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {addEmolumento.designacao} - {addEmolumento?.direccao}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button onClick={() => deleteEmolumento()} autoFocus>
              {loading ? <LoadingShort /> : 'Sim'}
            </Button>
          </DialogActions>
        </Dialog> */}
            </Card>
        </Container>
    );
}
